// ======================================================
// RECOMMENDED PRODUCTS HORIZONTAL SCROLL (BISON)
// Purpose: Scroll recommendation cards left/right
// Original from bison-newsite product-landing-page/sections/recommended
// ======================================================

window.scrollRecommendations = function (direction, element) {
    const section = element && element.closest ? element.closest('.recommend-bison') : null;
    const container = section ? section.querySelector('.row.g-4.recommend-row') : document.querySelector('.recommend-bison .row.g-4.recommend-row');
    if (container) {
        container.scrollBy({
            left: direction * 300,
            behavior: 'smooth'
        });
    }
};
